<template>
	<div>
		<v-dialog v-model="dialog_discount" v-if="dialog_discount" no-click-animation persistent lazy full-width width="290px" transition="dialog-bottom-transition">
        	<v-card>
        	  	<v-card-text>
        	  		<v-form data-vv-scope="entryNote">
                        <v-text-field
                            :label="'Enter ' + $parent.selectedAddOn.name + ' Percentage'"
                            v-model="addonValue"
                            placeholder=" " 
							type="number"
                        ></v-text-field>
        	  			<!-- <v-textarea 
        	  				text-field-top-bottom-margin
        	  				id="noteField" 
	        	  			v-validate="'max:255'"
		               		data-vv-name="note" 
		               		:error-messages="errors.collect('entryNote.note')" 
		               		rows="10" 
		               		v-model="noteValue"
		               		placeholder=" " 
		               		label="Add Notes" 
		               		:counter="255">
	               		</v-textarea> -->
        	  		</v-form>

					<v-alert type="info" :value="true" font-small>This percentage will apply to all items.</v-alert>
        	  	</v-card-text>
		        <v-card-actions>
		          <v-spacer></v-spacer>
		          <v-btn color="blue darken-1" flat @click.native="fn_closeDialog">close</v-btn>
		          <v-btn color="blue darken-1" flat @click.native="fn_applyPercentage">ok</v-btn>
		        </v-card-actions>
	        	</v-card>	
      	</v-dialog>
	</div>
</template>

<script>
export default{
	data(){	
		return{
			dialog_discount: false,
			addonValue:null
		}
	},
    props:['addOnName'],
	methods:{
		openDialogWeb: function () {	
			this.dialog_discount = true;
			this.addonValue = null;
		},
		closeDialogWeb: function () {
			this.dialog_discount = false;
		},
		fn_closeDialog: function(){
			if(this.$parent.fn_closeDialog){
				this.$parent.fn_closeDialog();
			}
			else{
				this.closeDialogWeb();
			}
		},
		fn_applyPercentage: function () {
			if(!this.addonValue){
				this.showToast('Please enter a valid ' + this.$parent.selectedAddOn.name + 'percentage');
				return;
			}

			// getting selected addons to apply on all items
			let itemsWithAddons = this.$parent.Form.items.filter(item=>{
				return item.addOnsItems && item.addOnsItems.length; 
			})

			let selectedAddonsData = null
			for(let k=0; k<itemsWithAddons.length; k++){
				for(let l=0; l<itemsWithAddons[k].addOnsItems.length; l++){
					if(itemsWithAddons[k].addOnsItems[l].addOnsId == this.$parent.selectedAddOn.addOnsId){
						selectedAddonsData = itemsWithAddons[k].addOnsItems[l];
						break;
					}
				}
				if(selectedAddonsData){
					break;
				}
			}
			// getting selected addons to apply on all items ends here

			for(let i=0; i<this.$parent.Form.items.length; i++){
				// if(!this.$parent.Form.items[i].addOnsItems || !this.$parent.Form.items[i].addOnsItems.length){
					// this.$parent.Form.items[i].addOnsItems = [selectedAddonsData];
					!this.$parent.Form.items[i].addOnsItems ? this.$parent.Form.items[i].addOnsItems = [] : '';
					let index = this.$parent.Form.items[i].addOnsItems.findIndex(addon=>{return addon.addOnsId == this.$parent.selectedAddOn.addOnsId})
					index == -1 ? this.$parent.Form.items[i].addOnsItems.push(selectedAddonsData) : '';
				// }

				for(let j=0; j<this.$parent.Form.items[i].addOnsItems.length; j++){
					if(this.$parent.Form.items[i].addOnsItems[j].addOnsId == this.$parent.selectedAddOn.addOnsId){
						this.$parent.Form.items[i].addOnsItems[j].percentage = Number(this.addonValue);
						break;
					}
				}
				this.$parent.Form.items[i].netAmount = this.$parent.$refs['ref_dialogProduct'].fn_computeValues(this.$parent.Form.items[i]);
			}
			this.fn_closeDialog();
		}
	}
}
</script>


// WEBPACK FOOTER //
// src/components/transactions/forms/dialogs/dialog_discount_whole.vue